/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import { IAddPersonalAccidentOrderTypes, IInvoice } from "shared/interface/types";

const initialState: { PersonalAccidentOrder: IAddPersonalAccidentOrderTypes; Invoice: IInvoice } = {
  PersonalAccidentOrder: {
    id: "",
    customerDetailId: "",
    name: "",
    personalAccidentPlanId: null,
    planName: "",
    productName: "",
    cartId: "",
    lineOfBussiness: {
      id: null,
      name: ""
    },
    takafulProvider: {
      id: "",
      companyName: ""
    },
    paymentFrequency: {
      id: null,
      name: ""
    },
    planType: {
      id: null,
      name: ""
    }
  },
  Invoice: {
    id: "",
    dueDate: "",
    amount: "",
    currencySymbol: "",
    paidAt: "",
    currencyId: 0,
    tax: "",
    createdById: "",
    updatedById: "",
    createdAt: "",
    updatedAt: "",
    activityFkId: "",
    payerUserId: "",
    paymentStatusId: 0,
    pickupAddress: "",
    activity: {
      id: 0,
      value: ""
    },
    type: {
      id: 0,
      value: ""
    },
    paymentStatus: {
      id: 0,
      key: "",
      value: ""
    },
    paymentMode: {
      id: 0,
      value: ""
    },
    paymentMethod: {
      id: 0,
      value: ""
    },
    currency: {
      id: 0,
      name: "",
      code: "",
      symbol: ""
    },
    totalContributionValue: "",
    amountValue: "",
    updatedBy: {
      id: 0,
      name: ""
    },
    payer: {
      id: "",
      contactNumber: "",
      name: "",
      isActive: true,
      email: "",
      profileImage: "",
      userType: {
        id: 0,
        key: ""
      }
    }
  }
};

const personalAccidentOrderSlice = createSlice({
  name: "personalAccidentOrder",
  initialState,
  reducers: {
    AddPersonalAccidentOrder: (state, action) => {
      state.PersonalAccidentOrder = action.payload;
    },
    AddOrderInvoice: (state, action) => {
      state.Invoice = action.payload;
    },
    DeletePersonalAccidentOrder: state => {
      state.PersonalAccidentOrder = initialState.PersonalAccidentOrder;
    }
  }
});

export const { AddPersonalAccidentOrder, AddOrderInvoice, DeletePersonalAccidentOrder } = personalAccidentOrderSlice.actions;
export default personalAccidentOrderSlice.reducer;

export const getPersonalAccidentOrder = (state: RootState) => state.personalAccidentOrder;
export const getInvoice = (state: RootState) => state.personalAccidentOrder;
